import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
// -------------------------------------------------------

class ProjectPostContents extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showProjectPostContents = this.showProjectPostContents.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal         : false,
      detail        : {},
      contents      : [],
      project_id    : null,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 投稿コンテンツ一覧の取得
   */
  showProjectPostContents(value) {
    
    let main_contents = [];
    try { main_contents = value.split(',').filter((t) => { if( t != '' ) return t; }); } catch(e) {}
    
    this.setState({ contents: main_contents });
    
    // モーダル表示
    this.toogleModal.bind(this)(true);
  }
  // -------------------------------------------------------
  
  /*
   * 投稿コンテンツの更新
   */
  setPostContents() {
    
    console.log(this.state.contents);
    this.props.update_ev.bind(this)(this.state.contents.join());
    
    // モーダル非表示
    this.toogleModal.bind(this)(false);
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの操作
   */
  toogleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ){
      Utils.unlockFixedContents();
    }
  }
  // -------------------------------------------------------
  
  /*
   * コンテンツ追加
   */
  plus(media_type) {
    let contents = this.state.contents;
    contents.push(media_type);
    this.setState({ contents: contents.sort() });
  }
  // -------------------------------------------------------
  
  /*
   * コンテンツ削除
   */
  remove(no) {
    let contents = this.state.contents;
    contents = contents.filter((d, key) => { if( key != no ) return d; });
    this.setState({ contents: contents.sort() });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.state.detail;
    
    let contents_temp = [];
    
    return (
      <div className="project-post-contents">
        <ContentsModal
          view     = {this.state.modal}
          width    = {600}
          height   = {330}
          close_ev = {this.toogleModal.bind(this, false)}
          html     = {
            <div className="modal-item">
              <div className="modal-main-contents">
                
                <h3>投稿するメディア</h3>
                
                <div className="preview">
                  { this.state.contents.map((id, key) => {
                    let name = Const.value.contents_type[id];
                    
                    let item_no = 1;
                    contents_temp.map((tid) => { if( tid == id ) item_no++; });
                    contents_temp.push(id);
                    
                    if( item_no > 1 ) name += (' '+ item_no);
                    
                    return (
                      <div key={key}>
                        {name}<i className="material-icons" onClick={this.remove.bind(this, key)}>close</i>
                      </div>
                    );
                  })}
                  {(this.state.contents.length == 0) && <p className="none">投稿種別を選択してください</p>}
                </div>
                
                <div className="manual-buttons">
                  { Const.value.contents_type_list.map((d, key) => {
                    return <div key={key} onClick={this.plus.bind(this, d.id)}><i className="material-icons">add</i>{d.name}を追加</div>;
                  })}
                </div>
                
                { (this.state.contents.length > 0)
                  ? <div className="button done" onClick={this.setPostContents.bind(this)}>保存</div>
                  : <div className="button off" >保存</div>
                }
                
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectPostContents;